import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel"]

  connect() {
    this.show(this.tabTargets.find((tab) => tab.classList.contains("active")) || this.tabTargets[0])
  }

  switch(event) {
    this.show(event.currentTarget)
  }

  show(activeTab) {
    const index = this.tabTargets.indexOf(activeTab)

    this.tabTargets.forEach((tab, i) => {
      tab.classList.toggle("active", tab === activeTab)
      tab.classList.toggle("bg-gray-800", i === index)
      tab.classList.toggle("text-white", i === index)
      tab.classList.toggle("bg-gray-900", i !== index)
      tab.classList.toggle("text-gray-400", i !== index)
    })

    this.panelTargets.forEach((panel, i) => {
      panel.classList.toggle("hidden", i !== index)
    })
  }
}
